import { Button, Stack, Text, useBreakpointValue } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Loading from 'components/loading'

import theme from 'theme'

import type { ButtonProps } from '@chakra-ui/react'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

export type ButtonPrimaryIconProps = {
  source: IconProp
  position?: 'left' | 'right'
}

type Props = {
  text?: string
  selected?: boolean
  icon?: ButtonPrimaryIconProps
  color?: string
  isLoading?: boolean
  hideSelectedIcon?: boolean
  onClick?: () => void
}

export type ButtonPrimaryProps = Props & Omit<ButtonProps, 'children' | 'color' | 'bgColor' | 'backgroundColor'>

const ButtonPrimary = ({
  icon,
  text,
  color,
  selected = false,
  isLoading = false,
  hideSelectedIcon,
  onClick,
  ...props
}: ButtonPrimaryProps) => {
  const isSmallViewport = useBreakpointValue({ base: true, lg: false })
  const fgColor = selected ? theme.colors.white : (color ?? theme.baseColors.primary.main)

  return (
    <Button
      h="35px"
      minH="35px"
      px={selected ? '8px' : '14px'}
      border={selected ? 'none' : (props.border ?? `solid 1px ${theme.colors.gray['300']}`)}
      borderRadius={props.borderRadius ?? '4px'}
      background={(props.background ?? selected) ? theme.baseColors.primary.main : (props.background ?? 'transparent')}
      _hover={
        props._hover ?? {
          background: selected ? theme.baseColors.primary.dark : (theme.colors.alpha.blackalpha['50'] ?? 'transparent'),
        }
      }
      _active={
        props._active ?? {
          bg: selected ? theme.baseColors.primary.dark : (theme.colors.alpha.blackalpha['200'] ?? 'transparent'),
        }
      }
      onClick={onClick}
      {...props}
    >
      <Stack direction={icon && icon.position === 'right' ? 'row-reverse' : 'row'} spacing="8px" align="center">
        {isLoading ? (
          <Loading size="sm" color={fgColor} />
        ) : (
          <>
            {icon && <FontAwesomeIcon icon={icon.source} size="sm" color={fgColor} />}
            {!(!text && isSmallViewport && selected) && (
              <Text textStyle="button2" color={fgColor} {...(props.fontSize && { fontSize: props.fontSize })}>
                {text ?? (selected ? 'Selected' : 'Select')}
              </Text>
            )}
          </>
        )}
        {selected && !hideSelectedIcon && (
          <FontAwesomeIcon icon={['far', 'check']} size="sm" color={theme.colors.white} />
        )}
      </Stack>
    </Button>
  )
}

export default ButtonPrimary
